module.exports = __webpack_public_path__ + "static/img/7.2799c2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/7.png
// module id = bi6T
// module chunks = 0